var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1701_4911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5236 7.78517C15.4086 7.60642 15.2111 7.50017 14.9999 7.50017H10.6249V0.625264C10.6249 0.330268 10.4187 0.0752718 10.1299 0.0140226C9.83618 -0.0484765 9.54869 0.102771 9.42869 0.371518L4.42876 11.6214C4.34251 11.8139 4.36126 12.0389 4.47626 12.2151C4.59126 12.3926 4.78875 12.5001 5 12.5001H9.37494V19.375C9.37494 19.67 9.58119 19.925 9.86993 19.9862C9.91368 19.995 9.95743 20 9.99993 20C10.2424 20 10.4687 19.8587 10.5712 19.6288L15.5711 8.37891C15.6561 8.18516 15.6399 7.96266 15.5236 7.78517Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1701_4911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.a63240f07e976f1b5bc7114b0840f83b.svg";
export { ForwardRef as ReactComponent };